import Barcode from 'react-barcode';
import { datinNumber, templateMock } from './constant';
import BoxitImage from '../../assets/images/boxit.jpg'
const PdfTemplate6 = ({ data, userInfo }: any) => {
  const renderData = data || templateMock;

  return (
    <>
      {renderData &&
        renderData.map((item: any) => (
          <div className="templates  [&>div]:text-[8pt]  flex flex-col   w-[9cm]  " style={{ pageBreakInside: 'avoid' }}>
            <div className="  border border-Black87   h-[1.4cm] flex  items-center  justify-between  p-2 ">
              <img src={BoxitImage} width={80} height={12} />
              <div className=" font-semibold ">
                شماره پشتیبانی :{' '}
                {userInfo?.text === 'datin' || userInfo?.text === datinNumber ? '02124597775' : '90007030'}
              </div>
            </div>

            <div className="h-[1.1cm]  flex items-center   p-1 border border-Black87">
              <span className=" font-semibold">گیرنده: </span>
              <span className=" mr-1"> {item.receiverProspectName} </span>
            </div>
            <div className="h-[1.1cm]  flex items-center   p-1 border border-Black87">
              <span className=" font-semibold">استان و شهر گیرنده: </span>
              <span className=" mr-1">
                {' '}
                {item.receiverState?.text
                  ? `${item.receiverState.text}-${item.receiverCityName || ''}`
                  : item.receiverCityName || ''}
              </span>
            </div>

            <div className="h-[1.5cm]  flex items-center   p-1 border border-Black87">
              <span className=" font-semibold">آدرس: </span>
              <span className=" mr-1 w-5/6 break-words"> {item.receiverAddress} </span>
            </div>

            <div className="flex h-[1.1cm] ">
              <div className=" w-[4.5cm] flex items-center  gap-1  p-1 border border-Black87">
                <span className=" font-semibold"> موبایل گیرنده: </span>
                <span className=" mr-1">{item.receiverProspectMobile}</span>
              </div>
              <div className=" w-[4.5cm] flex items-center  gap-1 p-1 border border-Black87">
                <span className=" font-semibold"> کد پستی: </span>
                <span className=" mr-1"></span>
              </div>
            </div>

            <div className="flex h-[1.4cm] ">
              <div className=" w-[4.5cm] flex flex-col justify-start   p-1 border border-Black87">
                <div>
                  <span className=" font-semibold text-[8pt]"> هزینه پس کرایه (ریال): </span>
                  <span className=" mr-1">
                    {item.paymentBy?.id=== 0 ? '' : `  ${item.grossPrice?.toLocaleString()}`}
                  </span>
                </div>
                <div className="mt-2">
                  <span className=" font-semibold text-[8pt]"> هزینه کالا (ریال): </span>
                  <span className=" mr-1">{item.costOfGoods?.toLocaleString() || ''}</span>
                </div>
              </div>
              <div className=" w-[4.5cm] flex items-start flex-col gap-y-2  p-1 border border-Black87">
                <span className=" font-semibold text-[7pt]"> مجموع هزینه قابل پرداخت توسط گیرنده(ریال):</span>

                <span className=" mr-1 text-[7pt] mt-[-5px]">{(item.grossPrice + item.costOfGoods)?.toLocaleString()}</span>
              </div>
            </div>

            <div className="flex   w-full ">
              <div className="flex flex-1 flex-col ">
                <div className="flex">
                  <div className=" w-[6cm] flex items-center   p-1 border border-Black87">
                    <span className=" font-semibold">فرستنده: </span>
                    <span className=" mr-1"> {item.senderName} </span>
                  </div>
                  <div className=" w-[1.5cm] flex flex-1 items-center justify-center    p-1 border border-Black87">
                    {!data ? (
                      <>
                        <span className=" font-semibold">ردیف چاپی: </span>
                        <span className=" mr-1">{item?.printIndex}</span>
                      </>
                    ) : (
                      <span>{item?.printIndex}</span>
                    )}
                  </div>
                </div>

                <div className="h-[1.2cm]  flex flex-1 items-center  p-1 border border-Black87">
                  <span className=" font-semibold">استان و شهر فرستنده: </span>
                  <span className=" mr-1">{item.senderCityName}</span>
                </div>

                <div className="h-[1.5cm]  flex flex-1 items-start  p-1 border border-Black87">
                  <span className=" font-semibold"> آدرس: </span>
                  <span className=" mr-1 w-5/6 break-words">{item.senderAddress}</span>
                </div>

                <div className=" h-[1cm] flex flex-1  gap-1 items-center p-1 border border-Black87">
                  <span className=" font-semibold"> موبایل فرستنده: </span>
                  <span className=" mr-1">{item.senderMobile}</span>
                </div>
                <div className=" h-[1.6cm] flex flex-1 items-start  p-1 border border-Black87">
                  <div className="barcodeWrapper">
                    {!data ? (
                      'بارکد'
                    ) : (
                      <Barcode
                        height={22}
                        width={1.9}
                        value={item.cprNumber}
                        displayValue={item.senderMobile !== datinNumber}
                        fontSize={10}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="w-[1.5cm] h-[6cm] bg-white p-1 border border-Black87  flex items-center relative ">
                {!data ? (
                  'بارکد'
                ) : (
                  <div className="!rotate-90 scale-[.65]  barcode-container absolute bottom-[-20px] left-[1px]   w-full">
                    <div className="barcodeWrapper">
                      <Barcode
                        width={2.6}
                        height={45}
                        value={item.cprNumber}
                        displayValue={item.senderMobile !== datinNumber}
                        fontSize={14}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}

      <style>{`
            @media print {
              @page {
                size: 9.1cm 14cm;
                padding:2px;
                
     
              }   
            }
            `}</style>
    </>
  );
};

export default PdfTemplate6;
